import { render, staticRenderFns } from "./CreateTeamBanner.vue?vue&type=template&id=03180580&scoped=true&"
import script from "./CreateTeamBanner.vue?vue&type=script&lang=js&"
export * from "./CreateTeamBanner.vue?vue&type=script&lang=js&"
import style0 from "./CreateTeamBanner.vue?vue&type=style&index=0&id=03180580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03180580",
  null
  
)

export default component.exports